import {defineStore} from 'pinia';

export const useUtilsStore = defineStore('utils', () => {
  const tutoriel = ref<boolean>(JSON.parse(localStorage.getItem('tutoriel') ?? 'null'));
  const dejaProposeAjoutIos = ref<boolean>(JSON.parse(localStorage.getItem('dejaProposeAjoutIos') ?? 'null'));

  watch(tutoriel, (newValue) => {
    localStorage.setItem('tutoriel', JSON.stringify(newValue));
  });

  watch(dejaProposeAjoutIos, (newValue) => {
    localStorage.setItem('dejaProposeAjoutIos', JSON.stringify(newValue));
  });

  const getTutoriel = () => {
    return tutoriel.value;
  };

  const setTutoriel = (data?: boolean) => {
    tutoriel.value = data ?? false;
  };

  const getDejaProposeAjoutIos = () => {
    return dejaProposeAjoutIos.value;
  };

  const setDejaProposeAjoutIos = (data?: boolean) => {
    dejaProposeAjoutIos.value = data ?? false;
  };

  return {
    getTutoriel,
    setTutoriel,
    getDejaProposeAjoutIos,
    setDejaProposeAjoutIos,
  };
});
